let $document = undefined
let formId = undefined
let form = undefined
let $submit = undefined
let userTypeField = undefined

window.App.Pages.AdditionalInformation = class AdditionalInformation {
  constructor() {
    $document = $(document)
    formId = "#additional-information"
    form = $(formId).parsley()
    $submit = $(formId).find('[type="submit"]')
    userTypeField = 'input[name="user[user_type_cd]"]'

    this.bindElements()
    this.toggleRelatedFields($(`${userTypeField}:checked`).val() || -1)
    if (!form.isValid()) {
      $submit.attr("disabled", "disabled")
    }
  }

  bindElements() {
    $document.on("change", userTypeField, e => {
      return this.toggleRelatedFields($(e.currentTarget).val())
    })

    return $document.on("change", `${formId} input`, function (e) {
      if (form.isValid()) {
        return $submit.removeAttr("disabled")
      } else {
        return $submit.attr("disabled", "disabled")
      }
    })
  }

  toggleRelatedFields(userType) {
    const allFields = "[data-show-usertype]"
    const activeFields = `[data-show-usertype='${userType}']`
    $(document).find(allFields).hide()
    $(document).find(`${allFields} input`).prop("disabled", true)
    $(document).find(activeFields).show()
    return $(document).find(`${activeFields} input`).prop("disabled", false)
  }
}

$(document).on("turbo:load", function () {
  if ($(document.body).hasClass("usersAdditionalInformationView")) {
    return new App.Pages.AdditionalInformation()
  }
})
